import React from "react";
import ProfileGridChoice from "../ProfilesGrid/ProfileGridChoice";
import formDefinitions from "../../data/schema/profiles/definitions";

export default class ProfilesGrid extends React.Component {
  render() {
    const profiles = formDefinitions.map(
      (form, index) =>
        !form.hidden && <ProfileGridChoice {...form} key={index} />
    );
    return (
      <div className={"usa-application-container"}>
        {profiles}
        <div className="usa-profile-box usa-application-empty">
          <h4 className="application-title">
            More profile types will be available soon.
          </h4>
        </div>
      </div>
    );
  }
}
